// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuex from 'vuex';
import VueClipboard from 'vue-clipboard2';
import VueCompositionAPI from '@vue/composition-api';

import env from '../config/env';
import App from './App';
import router from './router';
import store from './store';
import filters from './filters.js';
import init from './axios.js';
import vuetify from './plugins/vuetify';

store.state.env = env;
for (const filter in filters) {
	Vue.filter(filter, filters[filter]);
}

init(Vue);

Vue.use(Vuex);
Vue.use(VueClipboard);
Vue.use(VueCompositionAPI);

Vue.set(Vue.prototype, 'env', env);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
	el: '#admin2',
	router,
	store,
	components: { App },
	vuetify,
	template: '<App/>',
});

/*
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
*/
